import axios from "@/plugins/axios";

let url = "/api/console/common/emails";

export const emails = {
    post(data){
        return axios.post(`${url}`, data).then(result => result.data);
    },
}
